module.exports = __webpack_public_path__ + "static/media/icon-header-engagement.32688883.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Header/assets/icon-header-engagement.svg
// module id = 1508
// module chunks = 193